module.exports = __webpack_public_path__ + "img/file-text-blue.6ba20d80.svg";